import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PluckerPerformanceReport } from './Pages/listing';

export const PluckerPerformanceReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PluckerPerformanceReport} />
    </Fragment>
)